import { render, staticRenderFns } from "./ResultsTableWrapper.vue?vue&type=template&id=70a98f61&"
import script from "./ResultsTableWrapper.vue?vue&type=script&lang=js&"
export * from "./ResultsTableWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ResultsTableWrapper.vue?vue&type=style&index=0&id=70a98f61&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports